/**
 * Utilitários de Sanitização de Texto e Proteção de Layout para MeMed.
 * Evita quebras de fonte no PDF por tags coladas e valida o limite estrito
 * de 2.000 caracteres no campo historia_clinica (Capítulos 31 e 79).
 */

export function sanitizarTextoParaMemed(textoBruto: string): string {
  if (!textoBruto) return '';
  return textoBruto
    .replace(/<[^>]*>/g, '') // Remove tags HTML coladas
    .replace(/[\u2018\u2019]/g, "'") // Normaliza aspas curvas
    .replace(/[\u201C\u201D]/g, '"') // Normaliza aspas duplas
    .replace(/[\t\r]/g, ' ') // Converte tabs e carriage returns em espaços
    .replace(/\s+/g, ' ') // Remove espaços duplicados
    .trim();
}

export function validarHistoriaClinica(texto: string, maxChars = 2000): string {
  if (!texto) return '';
  const normalizado = texto.replace(/\r\n/g, '\n');
  if (normalizado.length > maxChars) {
    return normalizado.slice(0, maxChars - 5) + '...';
  }
  return normalizado;
}
